import { defineMessages } from 'react-intl'

export default defineMessages({
  Pay: {
    id: 'components.PaymentMethods.VisaInstallments.Pay',
    defaultMessage: 'Pay',
    description: '支付按钮文本',
  },
})
